<!-- home1 -->
<template>
  <div class="pb100">
    <Paperdetails ref="detailKey" :detailValue="detailValue"></Paperdetails>
    <div class="banner-img">
      <!-- <img src="../../assets/img/banner.png" alt> -->
      <el-carousel :interval="5000" height="210px" direction="vertical" :autoplay="true">
        <el-carousel-item v-for="item in 3" :key="item" :class="'bcimg'+item"></el-carousel-item>
      </el-carousel>
    </div>
    <div class="index-nav">
      <div class="container" style="text-align: center;">
        <div
          class="nav-item posite"
          :class="{'nav-active':(+item['id'])==navActive,'not-allow':item['state']==0}"
          v-for="(item) in navData"
          :key="item['id']"
          @click="changeNav(item)"
        >
          {{item.name}}
          <span v-if="item.state==2" class="new-2">NEW</span>
        </div>
      </div>
    </div>
    <div class="index-con">
      <div class="container">
        <div class="con-sub">
          <div class="sub-title">一级学科：</div>
          <div
            class="sub-item posite"
            :class="{'sub-active':index==subActive,'not-allow':item['state']==0}"
            v-for="(item,index) in classSub1"
            :key="index"
            @click="changeSub(item,index)"
          >
            {{item.name}}
            <span v-if="item.state==2" class="new">NEW</span>
          </div>
        </div>
        <div class="con-sub">
          <div class="sub-title">二级学科：</div>
          <div
            class="sub-item posite"
            :class="{'sub-active':index==subActive1,'not-allow':item['state']==0}"
            v-for="(item,index) in classSub2"
            :key="index"
            @click="changeSub1(item,index)"
          >
            {{item.name}}
            <span v-if="item.state==2" class="new">NEW</span>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="top100">
      <div class="container">
        <div class="title">
          <div class="con-sub">
            <div
              :class="item.index==subActive2?'sub-active':''"
              v-for="item in classSub3"
              :key="item.index"
              @click="changeSub2(item)"
              class="sub-item"
            >{{item.name}}</div>
          </div>
          <span class="right">
            {{scholarSwitch}}
            
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">收集了各学科近10年来的论文并结合<br/>
      人大复印库的转载情况，通过人工智<br/>
      能算法所鉴别出的优秀学者榜单，将<br/>
      作为ISE学者评价的初始参考。</div>
              <img class src="../../assets/question.svg" alt>
            </el-tooltip>
          </span>
        </div>
        <div class="table">
          <el-table v-loading="tableLoad" :data="tableData" style="width: 100%">
            <!-- <el-table-column type="index" align="center" label="序号" width="50"></el-table-column> -->

            <el-table-column label="姓名" width="100">
              <template slot-scope="scope">
                <a
                  @click="goHomePage(scope.row.aid,scope.row.treecode)"
                >{{scope.row.iname?scope.row.iname:scope.row.name}}</a>
              </template>
            </el-table-column>
            <el-table-column prop="company" label="单位" width="180">
              <template
                slot-scope="scope"
              >
              <span :title="scope.row.company">{{scope.row.icompany?scope.row.icompany:scope.row.company | lengthOf25(10)}}</span></template>
            </el-table-column>
            <el-table-column label="ISE评价" width="180">
              <template slot-scope="scope">{{scope.row.ise}}</template>
            </el-table-column>
            <el-table-column label="突出领域">
              <template slot-scope="scope">
                <div :title="scope.row.ikeywords">{{scope.row.ikeywords | lengthOf18}}</div>
              </template>
            </el-table-column>
            <el-table-column label="代表作（2009年以来发表）">
              <template slot-scope="scope">
                <a style="position:relative" :title="scope.row.title">
                  <span
                    @click="openPageDetail(scope.row.pid,scope.row.treecode)"
                  >{{scope.row.title | lengthOf25(25)}}</span>
                  <a
                    v-if="scope.row.rucartid && !tableLoad"
                    :href="'https://www.rdfybk.com/qw/detail?id='+scope.row.rucartid"
                    target="_blank"
                    class="rdfyk1"
                    title="人大复印库全文阅读"
                  ></a>
                </a>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="100"
            layout="prev, pager, next"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div class="container">
      <comment ref="pinglun" :pinglunValue="pinglunValue"></comment>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Comment from "./comment";
import https from "../../common/http.js";
import Paperdetails from "../common/paperdetails";
export default {
  components: {
    Comment,
    Paperdetails
  },
  //import引入的组件需要注入到对象中才能使用
  data() {
    //这里存放数据
    return {
      detailValue: "",
      tableLoad: false,
      pinglunValue: "",
      navActive: 1,
      subActive: 0,
      subActive1: 0,
      subActive2: 0,
      navData: [],
      classData: [],
      classSub1: [],
      classSub2: [],
      classSub3: [
        {
          name: "AAAAA",
          index: 0
        },
        {
          name: "AAAA",
          index: 1
        },
        {
          name: "AAA",
          index: 2
        }
      ],
      switchKey: false,
      scholarSwitch: "关于初始榜单",
      tableData: [],
      currentPage: 1,
      subObj: {},
      totalcount: 0,
      treecode: "",
      ise: "AAAAA"
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    openPageDetail(id, code) {
      this.$nextTick(() => {
        this.$refs.detailKey.open(id, code);
      });
    },
    getNavTitle() {
      let params = {};
      let _this = this;
      https
        .fetchPost("/iseapi/getisetreecode", params)
        .then(res => {
          if (res.error === 0) {
            _this.classData = res.data;
            res.data.forEach((item, index) => {
              if (item["topid"] === "0") {
                _this.navData.push(item);
              }
            });
            _this.changeNav(_this.navData[0]);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    openVn() {
      const h = this.$createElement;
      this.$message({
        message: h("p", null, [h("span", null, "榜单即将发布，敬请期待 ")]),
        offset: 100
      });
    },
    getTable(treecode, index) {
      let _this = this;
      let params = {
        treecode: treecode,
        pagesize: 100,
        pageindex: index,
        ise: _this.ise
      };
      _this.tableLoad = true;
      _this.$api
        .fetchGet("iseapi/getiseranklist", params)
        .then(res => {
          console.log(res);
          _this.tableData = res.data;
          _this.totalcount = res.totalcount;
          _this.tableLoad = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeNav(item) {
      if (item["state"] == 0) {
        this.openVn();
        return false;
      } else if (this.tableLoad) {
        return false;
      } else {
        let _this = this;
        _this.classSub1 = [];
        for (let it of _this.classData) {
          if (it["topid"] == item["id"] && +it["firstid"] == 0) {
            _this.classSub1.push(it);
          }
        }
        this.navActive = +item.id;
        this.subActive = 0;
        _this.substr = "";
        _this.subObj.substr1 = item.name + " > ";
        _this.changeSub(_this.classSub1[0], 0);

        this.subActive1 = 0;
      }
    },
    changeSub(item, index) {
      if (item["state"] == 0) {
        this.openVn();
        return false;
      } else if (this.tableLoad) {
        return false;
      } else {
        let _this = this;
        _this.classSub2 = [];
        for (let it of _this.classData) {
          if (it["firstid"] == item["id"] && it["topid"] == item["topid"]) {
            _this.classSub2.push(it);
          }
        }
        this.subActive = index;

        _this.subObj.substr2 = item.name + " > ";
        _this.changeSub1(_this.classSub2[0], 0);
      }
    },
    changeSub1(item, index) {
      if (item["state"] == 0) {
        this.openVn();
        return false;
      } else if (this.tableLoad) {
        return false;
      } else {
        let _this = this;
        _this.subActive1 = index;
        let treecode = item["topid"] + item["firstid"] + item["id"];
        _this.$nextTick(() => {
          let metaid = +item["topid"] + item["firstid"] + item["id"];
          _this.$refs.pinglun.getComment(metaid);
        });
        _this.subObj.substr3 = item.name;
        _this.treecode = treecode;
        _this.currentPage = 1;
        _this.ise = "AAAAA"
        _this.subActive2 = 0
        _this.getTable(treecode, 1);
        this.$router.push({
        path: "/home",
        query: {
          treecode: treecode
        }
      });
      }
    },
    changeSub2(item) {
      if (!this.tableLoad) {
        this.subActive2 = item.index;
        this.ise = item.name;
        this.currentPage = 1;
        this.getTable(this.treecode, this.currentPage);
      }
    },
    goHomePage(aid, code) {
      //this.$store.commit('mutationsChangeInput',this.input);
      let substr =
        this.subObj.substr1 + this.subObj.substr2 + this.subObj.substr3;
      this.$router.push({
        path: "/homepage",
        query: {
          id: aid,
          treecode: code,
          substr: substr
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if (!this.tableLoad) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
        this.getTable(this.treecode, val);
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$store.state.homeKey) {
    }
    this.getNavTitle();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
/* 轮播 */
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}
.banner-img {
  min-width: 1200px;
}
.banner-img .bcimg2 {
  background: url("../../assets/lunbo/lunbo1.png") no-repeat center top;
}
.banner-img .bcimg1 {
  background: url("../../assets/lunbo/lunbo2.png") no-repeat center top;
}
.banner-img .bcimg3 {
  background: url("../../assets/lunbo/lunbo3.png") no-repeat center top;
}
.el-carousel__item {
  /* background-size: cover; */
  height: 100%;
  width: 100%;
  background-size: 100%;
  overflow: hidden;
}
.pb100 {
  padding-bottom: 100px;
}
hr {
  height: 2px;
  background-color: #f1f1f1;
  border: none;
  margin-top: 50px;
  margin-bottom: 30px;
}
.banner-img img {
  width: 100%;
}

.index-nav {
  height: 65px;
  line-height: 65px;
}
.index-nav .nav-item {
  display: inline-block;
  width: 12%;
  font-size: 18px;
  color: #333;
  text-align: center;
  cursor: pointer;
  /* border-bottom:1px solid #F6F6F6; */
}
.not-allow {
  cursor: not-allowed !important;
  color: #aaa !important;
}
.nav-active {
  color: #4267b2 !important;
  border-bottom: 3px solid #4267b2;
  /* background: rgba(66, 103, 178, 1); */
}
.index-con .con-sub {
  margin-top: 30px;
}
.con-sub .sub-title,
.con-sub .sub-item {
  display: inline-block;
  font-size: 14px;
}
.con-sub .sub-item {
  margin-left: 30px;
  padding: 5px 15px;
  cursor: pointer;
}
.sub-active {
  background: rgba(66, 103, 178, 1);
  border-radius: 2px;
  color: #fff;
}
.top100 {
  font-size: 14px;
}

.top100 .title {
  height: 26px;
}
.top100 .con-sub {
  display: inline-block;
}
.top100 .con-sub .sub-item:first-child {
  margin: 0;
}
.top100 .title .right {
  float: right;
  color: #4267b2;
  cursor: pointer;
}
.top100 .title .right .item{
  letter-spacing:1px;
}
.top100 .title .right img {
  position: relative;
  top: 2px;
}
.pagination {
  margin-top: 65px;
  text-align: right;
}

.table {
  margin-top: 20px;
}
.table a {
  color: #4267b2;
}

.table .el-table th {
  background: rgba(66, 103, 178, 0.06);
  color: #999999 !important;
}

.table .rdfyk1 {
  background: url("../../assets/rdfyk.svg") no-repeat;
  background-size: 100%;
  position: absolute;
  display: inline-block;
  height: 14px;
  width: 16px;
  margin-left: 5px;
  margin-top: 4px;
  z-index: 10000;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4267b2 !important;
}
</style>


// WEBPACK FOOTER //
// src/view/home/home1.vue